<template>
<div class="main__section">
      <sidebar></sidebar>
      <div class="detailedstep">
        <div class="detailedstep__form">
              <p class="detailedstep__title">Complete your user profile</p>
              <div class="preview" :style="{ 'background-image': `url(${form.picture_preview})` }">
                  <p>Profile picture/Product pic/Logo</p>
                  <label for="profile-picture" class="preview__label">Upload</label>
                  <input type="file" name="picture" accept="image/*" id="profile-picture" ref="picture" class="preview__input" @change="handleFileUpload" />
              </div>
              <div class="detailedstep__input">
                <input type="text" name="first_name" placeholder="First Name*" class="input__text" :class="{ 'input__text--error': $v.form.first_name.$error }" v-model="$v.form.first_name.$model" />
                <span class="detailedstep__error" v-if="$v.form.first_name.$error && !$v.form.first_name.required">First name is required</span>
                <span class="detailedstep__valid" v-else>Field ok</span>
              </div>
              <div class="detailedstep__input">
                <input type="text" name="last_name" placeholder="Last Name*" class="input__text" :class="{ 'input__text--error': $v.form.last_name.$error }" v-model="$v.form.last_name.$model" />
                <span class="detailedstep__error" v-if="$v.form.last_name.$error && !$v.form.last_name.required">Last name is required</span>
                <span class="detailedstep__valid" v-else>Field ok</span>
              </div>

            <div class="detailedstep__input">
                <input type="text" name="phone_number" placeholder="Phone Number*" class="input__text" :class="{ 'input__text--error': $v.form.phone.$error }" v-model="$v.form.phone.$model" />
                <span class="detailedstep__error" v-if="$v.form.phone.$error && !$v.form.phone.required">Phone number is required</span>
                <span class="detailedstep__error" v-else-if="$v.form.phone.$error && !$v.form.phone.phoneValid">Please enter a valid phone number</span>
                <span class="detailedstep__valid" v-else>Field ok</span>
            </div>

              <div class="detailedstep__input">
                <input type="email" name="email" placeholder="Email address*" class="input__text" :class="{ 'input__text--error': $v.form.email.$error || (getServerErrors && getServerErrors['user.email'])}" v-model="$v.form.email.$model" />
                <span class="detailedstep__error" v-if="$v.form.email.$error && !$v.form.email.required">Email is required</span>
                <span class="detailedstep__error" v-else-if="$v.form.email.$error && !$v.form.email.email">Please enter a valid email</span>
                <span class="detailedstep__error" v-else-if="getServerErrors && getServerErrors['user.email']">This email is already in our database. Please <a href="https://whatswhat.ie">click here</a> to login using this email address.</span>
                <span class="detailedstep__valid" v-else>Field ok</span>
              </div>
              <div class="detailedstep__input">
                <input type="email" name="email_confirmation" placeholder="Retype your email address*" @paste.prevent class="input__text" :class="{ 'input__text--error': $v.form.email_confirmation.$error }" v-model="$v.form.email_confirmation.$model" />
                <span class="detailedstep__error" v-if="$v.form.email_confirmation.$error && !$v.form.email_confirmation.required">Email is required</span>
                <span class="detailedstep__error" v-else-if="$v.form.email_confirmation.$error && !$v.form.email_confirmation.sameAsEmail">Please enter the same email</span>               
                <span class="detailedstep__valid" v-else>Field ok</span>
              </div>
              <div class="detailedstep__input">
                <input type="password" name="password" placeholder="Password*" class="input__text" :class="{ 'input__text--error': $v.form.password.$error }" v-model="$v.form.password.$model" />
                <span class="detailedstep__error" v-if="$v.form.password.$error && !$v.form.password.required">Password is required</span>
                <span class="detailedstep__error" v-else-if="$v.form.password.$error && !$v.form.password.minLength">Please add minimum 6 characters</span>
                <span class="detailedstep__valid" v-else>Field ok</span>
              </div>
              <div class="detailedstep__input">
                <input type="password" name="password_confirmation" placeholder="Retype password*" class="input__text" :class="{ 'input__text--error': $v.form.password_confirmation.$error }" v-model="$v.form.password_confirmation.$model" />
                <span class="detailedstep__error" v-if="$v.form.password_confirmation.$error && !$v.form.password_confirmation.required">Password confirmation is required</span>
                <span class="detailedstep__error" v-else-if="$v.form.password_confirmation.$error && !$v.form.password_confirmation.sameAsPassword">Please retype the same password</span>
                <span class="detailedstep__valid" v-else>Field ok</span>
              </div>
              <div class="detailedstep__form detailedstep__form--two">
                 <a href="#" class="button__next button__next--fixed text-white" @click.prevent="goBack()">Back</a>
                  <a href="#" class="button__next text-white" @click.prevent="saveData()">Next Step</a>
              </div>   
              <loading :show="getLoadingState"></loading>
        </div>
      </div>
      <single-testimonial></single-testimonial>
    </div>
</template>

<script>
import {mapActions, mapGetters } from 'vuex';
import SingleTestimonial from '../testimonials/SingleTestimonial';
import Sidebar from '../sidebar/Sidebar';
import { required,email,sameAs,minLength } from 'vuelidate/lib/validators';
import Loading from '../Loading.vue';
const isPhone = (value) => /^[0-9$\-() +]+$/.test(value)
export default {
components:{
        'sidebar':Sidebar,
        'single-testimonial':SingleTestimonial,
        'loading':Loading
    },
data(){
  return{
    form:{
      picture:null,
      picture_preview: '',
      first_name:'',
      last_name:'',
      phone: '',
      email:'',
      email_confirmation:'',
      password:'',
      password_confirmation:''
    },
  }
},
validations:{
   form:{
        first_name:{
          required
        },
        last_name:{
          required
        },
        phone: {
            required,
            phoneValid: isPhone
        },
        email:{
          required,
          email,
        },
        email_confirmation:{
          required,
          sameAsEmail: sameAs('email')
        },
        password:{
          required,
          minLength:minLength(6)
        },
        password_confirmation:{
          required,
          sameAsPassword: sameAs('password')
        }
   }       
},
    methods:{
      ...mapActions([
        'saveYourProfile',
         'changeStep'
      ]),
      saveData(){
        this.$v.$touch();

        if(this.$v.$invalid){
            return;
        }else{
          this.saveYourProfile(this.form);
        }
      },
        handleFileUpload(){
            this.form.picture = this.$refs.picture.files[0];

            let reader  = new FileReader();

            reader.addEventListener("load", function () {
                this.form.picture_preview = reader.result;
            }.bind(this), false);

            if( this.form.picture ){
                if ( /\.(jpe?g|png|gif)$/i.test( this.form.picture.name ) ) {
                    reader.readAsDataURL( this.form.picture );
                }
            }
        },
      pickFile (e) {

            let file = e.target.files
            if (file && file[0]) {
              let reader = new FileReader();
              reader.readAsDataURL(file[0]);
              reader.onload = e => {
                this.form.profile_picture = e.target.result;
              }
            }
        },
        goBack(){
        this.changeStep(4);
    }
    },
    computed:{
    ...mapGetters([
            'getServerErrors',
            'getLoadingState'
        ])
    }
}
</script>

<style>

</style>